import { Button } from '@repo/go-ui';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';

import type { ReadonlyDeep } from '../../types/readonly-deep';
import type { TTrajectory } from '../../types/trajectory';

import styles from './trajectory-list-sidebar.module.scss';

type Props = {
  trajectory: ReadonlyDeep<TTrajectory>;
  selected: boolean;
  onSelect: (trajectoryId: number) => void;
};

function isTrajectoryActive(trajectory: ReadonlyDeep<TTrajectory>): boolean {
  return Boolean(trajectory.active ?? trajectory.definitive);
}

export function TrajectoryListItem({ trajectory, selected, onSelect }: Props) {
  const { t } = useTranslation();
  const active = isTrajectoryActive(trajectory);

  return (
    <Button
      type="button"
      variant="flat"
      size="s"
      className={clsx(styles.listItem, selected && styles.listItemSelected)}
      onClick={() => onSelect(trajectory.id)}
    >
      <span className={styles.listItemTitle}>{trajectory.citation.title}</span>
      {active && <span className={styles.listItemBadge}>{t('ListSidebar.active')}</span>}
    </Button>
  );
}
